import { toast } from 'react-toastify';
import { ToastTypes } from 'common/types/toasts';

/**
 * Show toast notification. Inherits config from <ToastContainer> in app.tsx.
 * No per-call overrides — all toasts use the global config (position, autoClose, etc.)
 */
export const showToast = (type: ToastTypes, message: string) => {
  switch (type) {
    case ToastTypes.error: toast.error(message); break;
    case ToastTypes.warning: toast.warning(message); break;
    case ToastTypes.info: toast.info(message); break;
    case ToastTypes.success: toast.success(message); break;
    default: break;
  }
};
